import { NotificationCenterComponent } from '../../components/notification-center/notification-center';
import { CommunicationService } from '../../../core/services/communication.service';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { TenantFormattingService } from '../../../core/services/tenant-formatting.service';
import { RouterOutlet, RouterLink, RouterLinkActive, Router } from '@angular/router';
import { faHome, faListAlt, faUserCircle, faFolderOpen, faGear, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { AuthService } from '../../auth/auth.service';
@Component({
  selector: 'app-main-layout',
  imports: [NotificationCenterComponent, RouterOutlet, FaIconComponent, RouterLink, RouterLinkActive],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.css'
})
export class MainLayoutComponent implements OnDestroy {
  ngOnDestroy(): void { this.communication.stop(); this.formatting.reset(); }
  @HostListener('window:focus')
  refreshFormats(): void { this.formatting.load(); }
  protected readonly faHome = faHome;
  protected readonly faListAlt = faListAlt;
  protected readonly faFolderOpen = faFolderOpen;
  protected readonly faGear = faGear;
  protected readonly faUserCircle = faUserCircle;
  protected readonly faRightFromBracket = faRightFromBracket;
  email = '';
  constructor(private auth: AuthService, private router: Router, public communication: CommunicationService, private formatting: TenantFormattingService) {
    this.email = auth.loggedInEmail ?? '';
    this.formatting.load();
    communication.start();
  }
  logout(): void {
    this.communication.stop();
    this.auth.logout().subscribe(() => {
      void this.router.navigate(['/login']);
    });
  }
}
